import {
  getModalitySemanticIdentity,
  isMeaningfulThought,
  type ReasoningStepDisplayMetadata,
} from '@littlebird/ui-utils';

import { userStore } from '@/stores/user.store';

import {
  getModalityDisplayLabelParts,
  modalityHasDetailContent,
} from './modality-registry';
import {
  ReasoningStepType,
  type ReasoningStep as ReasoningStepT,
} from './reasoning.types';
import { getStepTitle } from './reasoning.utils';

export function stepHasDetailContent(
  step: ReasoningStepT,
  isActive: boolean
): boolean {
  if (step.type === ReasoningStepType.Thought) {
    return isMeaningfulThought(step.hiddenContent);
  }
  if (step.type === ReasoningStepType.Modality) {
    return modalityHasDetailContent(step.modality, {
      isActive,
      toolCall: step.toolCall,
      isInternalUser: userStore.isInternalUser,
    });
  }
  return false;
}

export function getStepDisplayLabelParts(
  step: ReasoningStepT
): string[] | undefined {
  if (step.type === ReasoningStepType.Thought) {
    return isMeaningfulThought(step.hiddenContent)
      ? [getStepTitle(step, false)]
      : undefined;
  }
  if (step.type === ReasoningStepType.Modality) {
    return getModalityDisplayLabelParts(
      step.modality,
      step.toolCall,
      false,
      userStore.isInternalUser
    );
  }
  return undefined;
}

export function getStepDisplayMetadata(
  step: ReasoningStepT
): ReasoningStepDisplayMetadata {
  if (step.type === ReasoningStepType.Thought) {
    return { visible: isMeaningfulThought(step.hiddenContent) };
  }

  const labelParts = getStepDisplayLabelParts(step);
  if (!labelParts?.length) return { visible: false };

  return {
    visible: true,
    collapseKey: stepHasDetailContent(step, false)
      ? undefined
      : JSON.stringify([
          getModalitySemanticIdentity(step.modality),
          labelParts,
        ]),
  };
}
